module.exports = __webpack_public_path__ + "static/media/singingbowl.c54526da.mp3";